var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('trade-orders',{attrs:{"deal":_vm.deal_view}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }